import React, { useState, useEffect, useCallback } from "react";
import { Box, Stack, Typography, Chip, Button, Alert } from "@mui/material";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import axios from "axios";
import { BACKEND_URL } from "../../utils/constants";

export default function TakPanel() {
  const [status, setStatus] = useState(null);
  const [msg, setMsg] = useState(null);

  const load = useCallback(async () => {
    try {
      const r = await axios.get(`${BACKEND_URL}/tak/status`);
      setStatus(r.data);
    } catch {
      setStatus(null);
    }
  }, []);

  useEffect(() => {
    load();
    const id = setInterval(load, 5000);
    return () => clearInterval(id);
  }, [load]);

  const onFile = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    const fd = new FormData();
    fd.append("package", f);
    setMsg({ sev: "info", text: "Importing package…" });
    try {
      const r = await axios.post(`${BACKEND_URL}/tak/import`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setMsg({ sev: "success", text: `Imported — connecting to ${r.data?.host || "TAK"}…` });
      load();
    } catch (err) {
      setMsg({ sev: "error", text: err?.response?.data?.message || "Import failed." });
    }
  };

  const clear = async () => {
    try {
      await axios.delete(`${BACKEND_URL}/tak/package`);
      setMsg({ sev: "success", text: "Package removed." });
      load();
    } catch {
      setMsg({ sev: "error", text: "Failed to remove." });
    }
  };

  const s = status || {};
  const tone = s.connected ? "success" : s.package_loaded ? "warning" : "default";
  return (
    <Box>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }} flexWrap="wrap" useFlexGap>
        <Typography sx={{ fontWeight: 700 }}>TAK link</Typography>
        <Chip
          size="small"
          color={tone}
          label={s.connected ? `connected ${s.host || ""}` : s.package_loaded ? "package loaded" : "no package"}
        />
        {s.connected && <Chip size="small" label={`${s.marker_count ?? 0} markers`} />}
        <Box sx={{ flex: 1 }} />
        <Button size="small" component="label" startIcon={<UploadFileRoundedIcon />}>
          Import package
          <input hidden type="file" accept=".zip,application/zip" onChange={onFile} />
        </Button>
        {s.package_loaded && (
          <Button size="small" color="warning" onClick={clear}>Remove</Button>
        )}
      </Stack>
      <Typography variant="caption" sx={{ color: "text.secondary" }}>
        Import the ATAK data package (.zip from the TAK server). Guns connected to TAK then appear in
        the Gun Position tool's “From TAK” picker, so you can drop a gun on a marker instead of typing its grid.
      </Typography>
      {s.available === false && (
        <Alert severity="warning" sx={{ mt: 1 }}>TAK support isn't available in this build (pytak missing).</Alert>
      )}
      {s.error && <Alert severity="error" sx={{ mt: 1 }}>{s.error}</Alert>}
      {msg && <Alert severity={msg.sev} sx={{ mt: 1 }} onClose={() => setMsg(null)}>{msg.text}</Alert>}
    </Box>
  );
}
